export default "/images/dbbf0813fae795bde49cd1790776d8f5.avif";